
var Sticky = require('./dist/sticky.compile.js');

module.exports = Sticky;



//////////////////
// WEBPACK FOOTER
// /var/vhost/homefidence/web/app/themes/bryan/node_modules/sticky-js/index.js
// module id = 12
// module chunks = 0